<!-- simple 404 page -->
<p>Page not found</p>
<small>404</small>
